import { useEffect, useState } from "react";
import usePaymentFlow from "../../../Hooks/usePaymentFlow";
import { FaFilePdf, FaRegCreditCard } from "react-icons/fa6";
import { ConvertPriceToString, datePlus7DaysYYYYMMDDHHmmss, dateToYYYYMMDD } from "../../../Helpers/CustomConverter";
import useDownloadFinanceDocuments from "../../../Hooks/useDownloadFinanceDocuments";
import LoadingSpinner from "../../Components/LoadingSpinner";
import { formatDocumentNumber } from "../../../Helpers/DocumNumHelper";
import { useAuth } from "../../../Providers/AuthProvider";
import { useInvoices } from "../../../Providers/InvoicesProvider";
import InvoiceItems from "../Invoices/InvoiceItems";
import { Licenses } from "../../../Data/Licenses.ts";
import { useParams } from "../../../Providers/ParamsProvider";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { usePayment } from "../../../Providers/PaymentProvider";
import YesNoMessageModal from "../../Components/Modals/YesNoMessageModal";
import PaymentWithValueModal from "../../Components/Modals/PaymentWithValueModal.jsx";
import { reverseDate } from "../../../Helpers/ValidatorHelper.jsx";

const UnPaidInvoice = ({ invoice, setShowNoEInvoiceModal }) => {
    const [isChecked, setIsChecked] = useState(false);
    const dateToCompare = new Date(invoice.dateToPay);
    const { downloadFinanceDocument, isLoading } = useDownloadFinanceDocuments();
    const { authState } = useAuth()
    const { handleGetUnPaidInvoiceItems } = useInvoices()
    const [showItems, setShowItems] = useState(false)
    const [invoiceItems, setInvoiceItems] = useState([])
    const [isLoadingItems, setIsLoadingItems] = useState(false)
    const { license } = useParams();
    const today = new Date();
    var textColor = '#000000'
    const { activePaymentSuppliersForSites } = usePayment()
    const isElavonActive = activePaymentSuppliersForSites.some(s => s.supplierName === 'Elavon')
    const { createPaymentAndRedirect } = usePaymentFlow()
    const [showMessageAskToPay, setShowMessageAskToPay] = useState(false)

    // Normalizacja dat (usuwanie czasu)
    const dateToCompareStart = new Date(dateToCompare.getFullYear(), dateToCompare.getMonth(), dateToCompare.getDate());
    const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate());

    // Obliczanie różnicy dni
    const differenceInTime = dateToCompareStart - todayStart; // Wynik w milisekundach
    const differenceInDays = -Math.round(differenceInTime / (1000 * 60 * 60 * 24)); // Przeliczenie na dni

    const popoverPaid = <Popover id="popover-basic">
        <Popover.Body className="text-center">
            <span className='primary-accent-color-text'>Dokument w pełni opłacony</span>
        </Popover.Body>
    </Popover>

    const popoverToPay = <Popover id="popover-basic">
        <Popover.Body className="text-center">
            <span className='primary-accent-color-text'>Opłać dokument</span>
        </Popover.Body>
    </Popover>

    if (differenceInDays > 0 && invoice.remainToPaid >= 0) {
        textColor = '#d81b24'
    } else {
        textColor = '#000000'
    }

    useEffect(() => {
        if (showItems) {
            handleGetInvoiceItems()
        }
    }, [showItems])

    const handleCheckboxChange = () => {
        setIsChecked(!isChecked);
    };

    const handleAskToPayModal = async (amountToPay) => {
        setShowMessageAskToPay(false)
        if (amountToPay) {
            await createPaymentAndRedirect({
                orderId: `${formatDocumentNumber(invoice.docNumber, invoice.docCreated, invoice.wh).replaceAll('/', '-')}`,
                docOrderId: invoice.docNumber,
                docOrderDate: dateToYYYYMMDD(invoice.docCreated),
                siteId: invoice.wh,
                userId: authState.user.userId,
                custId: authState.custId,
                amount: amountToPay,
                customerEmail: authState.user.email,
                paymentTitle: `Dok. nr ${formatDocumentNumber(invoice.docNumber, invoice.docCreated, invoice.wh)}`,
                gateWayId: -1,
                paymentExpDate: datePlus7DaysYYYYMMDDHHmmss()
            })
        }
    }

    const handleDownloadPdf = () => {
        if ((authState.user && authState.user.customerInfo && authState.user.customerInfo[0].isEInvoiceConsent) || (authState.user && authState.user.isOperator)) {
            downloadFinanceDocument(invoice.docNumber, invoice.docCreated, invoice.wh)
            return
        }
        else {
            setShowNoEInvoiceModal(true)
        }
    }

    const handleGetInvoiceItems = async () => {
        setIsLoadingItems(true)
        const invoiceItems = await handleGetUnPaidInvoiceItems(invoice)
        setInvoiceItems(invoiceItems)
        setIsLoadingItems(false)
    }

    let creditCardStyle = isElavonActive ? '' : 'd-none'

    return (
        <>
            <tr className={`hoverable-row${invoice.docNumber.startsWith('$K') ? '' : ' element-pointer'}`}>
                <td style={{ alignContent: "center", verticalAlign: 'middle', textAlign: 'left', fontSize: '14px' }} onClick={() => setShowItems(!showItems)}>
                    <span style={{ color: textColor }}>
                        {differenceInDays > 0 && invoice.remainToPaid >= 0 ? <>{differenceInDays + ' dni'}<br />
                            <span style={{ fontWeight: "bold" }}>{reverseDate(invoice.dateToPay.substring(0, invoice.docCreated.indexOf("T")))}</span></> :
                            <span style={{ fontWeight: "bold" }}>{reverseDate(invoice.dateToPay.substring(0, invoice.docCreated.indexOf("T")))}</span>}
                    </span>
                </td>
                <td style={{ alignContent: "center", verticalAlign: 'middle', fontSize: '14px' }} onClick={() => setShowItems(!showItems)}>{license == Licenses.TgInstalacje ? invoice.seller.toLocaleLowerCase().replace('tg instalacje sp. z o.o. ', '').toLocaleUpperCase() : invoice.seller}</td>
                <td style={{ alignContent: "center", fontSize: '14px' }} onClick={() => setShowItems(!showItems)}>{invoice.docName}</td>
                <td style={{ alignContent: "center", verticalAlign: 'middle', fontSize: '14px' }} onClick={() => setShowItems(!showItems)}>{formatDocumentNumber(invoice.docNumber, invoice.docCreated, invoice.wh)}</td>
                <td style={{ alignContent: "center", verticalAlign: 'middle', fontSize: '14px' }} onClick={() => setShowItems(!showItems)}>
                    {reverseDate(invoice.docCreated.substring(0, invoice.docCreated.indexOf("T")))}
                </td>
                <td style={{ alignContent: "center", verticalAlign: 'middle', textAlign: "right", fontSize: '14px' }} onClick={() => setShowItems(!showItems)}>
                    <span style={{ fontWeight: "bold" }}>{ConvertPriceToString(invoice.value, null)}</span>
                    <br />
                    {ConvertPriceToString(invoice.paidValue, null)}
                </td>
                <td style={{ alignContent: "center", verticalAlign: 'middle', textAlign: 'right', fontSize: '14px' }} onClick={() => setShowItems(!showItems)}>
                    {ConvertPriceToString((invoice.remainToPaid), null)}

                </td>
                <td style={{ fontSize: '14px', verticalAlign: 'middle' }} onClick={() => setShowItems(!showItems)}>
                    {invoice.comments}
                </td>
                <td className={creditCardStyle} style={{ alignContent: "center", verticalAlign: 'middle', textAlign: 'center' }}>
                    {invoice.remainToPaid > 0 ? <OverlayTrigger trigger={["hover", "focus"]} placement="bottom" overlay={popoverToPay}><span><FaRegCreditCard style={{ cursor: "pointer" }} color="black" size={20} onClick={() => setShowMessageAskToPay(true)} /></span></OverlayTrigger> : invoice.remainToPaid < 0 ? <></> : <OverlayTrigger trigger={["hover", "focus"]} placement="bottom" overlay={popoverPaid}><span><FaRegCreditCard style={{ cursor: "pointer" }} color="green" size={20} /></span></OverlayTrigger>}
                </td>
                <td style={{ alignContent: "center", verticalAlign: 'middle', textAlign: "center" }}>
                    {invoice.docNumber.startsWith('$K') ?
                        (null)
                        :
                        (isLoading ? <LoadingSpinner width={2} height={2} bubble={false} /> : <FaFilePdf style={{ cursor: "pointer" }} color="black" size={20} onClick={() => handleDownloadPdf()} />)}
                </td>
            </tr >
            {showItems && !invoice.docNumber.startsWith('$K') && (
                <tr>
                    <td colSpan="10" style={{ padding: 10 }}>
                        <InvoiceItems items={invoiceItems} isLoading={isLoadingItems} />
                    </td>
                </tr>
            )}
            <PaymentWithValueModal
                show={showMessageAskToPay}
                onHide={handleAskToPayModal}
                docNo={formatDocumentNumber(invoice.docNumber, invoice.docCreated, invoice.wh)}
                valueToPay={invoice.remainToPaid}
            />
        </>
    )
}

export default UnPaidInvoice
